import { distribution } from 'redevConfig'

const list = (distribution && distribution.list) || ''
const distributionPage = list ? require(`redevelopment/outputManage/distribution/${list.templateName}`) : require('./view/distribution.html')
export default {
    base: {
        state: 'outputManage.stock.distribution',
        config: {
            url: '/distribution',
            abstract: true,
            template: '<div ui-view></div>',
            title: '发票分配',
            default: 'outputManage.stock.distribution.list',
        },
    },
    list: {
        state: 'outputManage.stock.distribution.list',
        config: {
            url: '/list',
            template: distributionPage,
            controller: 'distributionCtrl',
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/distribution/routers.js